import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('sugarplum_vault', {
  cherry: 'sugarplum',
  lemon: 'candied_jewel',
  orange: 'gold_coin_choc',
  bell: 'royal_bonbon',
  star: 'crown_wild',
  seven: 'candy_throne',
  gem: 'amethyst_sugar',
  scatter: 'treasure_chest',
  money: 'grand_vault',
});

/** Sugarplum Vault — GENERATED by scaffoldSlot from
 *  content/slots/sugarplum_vault.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const SUGARPLUM_VAULT_THEME: Theme = {
  id: 'sugarplum_vault',
  name: 'Sugarplum Vault',
  palette: {
    accent: 0xf0c860,
    secondary: 0x8e3bd6,
    warm: 0xffe6a0,
    frameFill: 0x230a33,
    bgGradientTop: 0x2e0f44,
    bgGradientBottom: 0x100418,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Sugarplum', glyph: '🟣', tint: 0x8e3bd6, weight: 5, textureAlias: 'sugarplum_vault:cherry',
        winVideoAlias: 'sugarplum_vault:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Candied Jewel', glyph: '💜', tint: 0xb06bff, weight: 5, textureAlias: 'sugarplum_vault:lemon',
        winVideoAlias: 'sugarplum_vault:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Gold Coin Chocolate', glyph: '🟡', tint: 0xf0c860, weight: 4, textureAlias: 'sugarplum_vault:orange',
        winVideoAlias: 'sugarplum_vault:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Royal Bonbon', glyph: '🍬', tint: 0x8e3bd6, weight: 3, textureAlias: 'sugarplum_vault:bell',
        winVideoAlias: 'sugarplum_vault:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Sugarplum Crown', glyph: '👑', tint: 0xf0c860, weight: 2, textureAlias: 'sugarplum_vault:star',
        winVideoAlias: 'sugarplum_vault:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Candy Throne', glyph: '🪑', tint: 0x8e3bd6, weight: 2, textureAlias: 'sugarplum_vault:seven',
        winVideoAlias: 'sugarplum_vault:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Amethyst Sugar Gem', glyph: '💎', tint: 0x8e3bd6, weight: 2.5, textureAlias: 'sugarplum_vault:gem',
        winVideoAlias: 'sugarplum_vault:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Candy Treasure Chest', glyph: '🧰', tint: 0xf0c860, weight: 0.5, textureAlias: 'sugarplum_vault:scatter',
        winVideoAlias: 'sugarplum_vault:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'The Grand Vault', glyph: '🪙', tint: 0xf0c860, weight: 1, textureAlias: 'sugarplum_vault:money',
        winVideoAlias: 'sugarplum_vault:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x230a33, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xf0c860, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffe6a0, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x230a33, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x8e3bd6, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xf0c860, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffe6a0, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x230a33, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffe6a0, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xf0c860, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffe6a0, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xffe6a0, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'sugarplum_vault:bg', path: 'environment/sugarplum_vault.png' },
      columnBackground: { alias: 'sugarplum_vault:column_bg', path: 'reel/sugarplum_vault_column_bg.png' },
      border: { alias: 'sugarplum_vault:border', path: 'brand/border_candy.png' },
    },
  },
};
